<template>
    <div class="news">
        <div class="news-content">
            <div class="navbar">
                <div class="navbar-logo">
                    <router-link :to="{name: 'home'}"
                                 title="Группа компаний Ренна">Группа компаний Ренна</router-link>
                </div>
                <div class="navbar-control">
                    <div class="navbar-menu"
                         title="Закрыть"
                         @click="close"
                    ><span></span></div>
                </div>
            </div>
            <div class="single"
                 v-if="detail"
            >
                <div class="single-time">{{ detail.date }}</div>
                <h1>{{ detail.title }}</h1>
                <p><img v-id="detail.bg"
                        :src="detail.bg"
                        :alt="detail.title"></p>

                {{ detail.text }}

                <ul class="single-page">
                    <li><a href="#"
                           @click.prevent.stop="close">закрыть новость</a></li>
                </ul>
            </div>
            <div class="news-foot">
                <div class="container">
                    <ul class="copyright">
                        <li>&copy;&nbsp;2018&nbsp;&mdash; 2019 Renna</li>
                    </ul>
                    <ul class="social">
                        <li class="social-item"><a href="https://vk.com/korovka_iz_korenovki"
                                                   target="_blank"
                                                   class="vk"></a></li>
                        <li class="social-item"><a href="https://www.facebook.com/korovka.iz.korenovki.official/"
                                                   target="_blank"
                                                   class="fb"></a></li>
                        <li class="social-item"><a href="https://www.youtube.com/user/Korenovka"
                                                   target="_blank"
                                                   class="yo"></a></li>
                        <!--<li class="social-item"><a href="javascript:;" class="tw"></a></li>-->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    const BASE_LINK = "/api/news/";

    export default {
        name: "detail",
        props: ["id"],
        data() {
            return {
                detail: null
            };
        },
        methods: {
            close() {
                this.$emit("close");
            }
        },
        mounted() {
            axios.get(BASE_LINK + this.id)
                .then((response) => {
                    this.detail = response.data;
                });
        }
    }
</script>
